import { PageGenerator } from "./page_generator";

/**
 * Default timeout in milliseconds for report generation.
 * After this time, the report will signal completion even if generation is not finished.
 */
export const DEFAULT_REPORT_TIMEOUT_MS = 30000;

export interface ContentProvider {
    getContent(): Promise<PageGenerator[]>

    /**
     * Optional timeout in milliseconds for report generation.
     * If not provided, DEFAULT_REPORT_TIMEOUT_MS (30 seconds) will be used.
     * After this timeout, the report-end-marker will be enabled regardless of completion state.
     */
    getTimeoutMs?(): number
}